export default __webpack_public_path__ + "static/loading-38986fa3b32f3f7cd23c3ad625de25eb.gif";